import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material'
import Box from '@mui/material/Box'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useTheme } from '@mui/material/styles'
import Logo from '../resources/LogoMoovyWhite.svg'
import { FormattedMessage } from 'react-intl'
import { Language } from './app'

interface KioskAppBarProps {
  language: Language
  onLanguageChange: (language: Language) => void
}

const KioskAppBar = ({ language, onLanguageChange }: KioskAppBarProps) => {
  const theme = useTheme()

  const handleChange = (event: SelectChangeEvent) => {
    const selectedLanguage = event.target.value as Language
    onLanguageChange(selectedLanguage)
  }

  const languageOptions = [
    {
      value: 'fi',
      label: <FormattedMessage id="language.finnish" />
    },
    {
      value: 'en',
      label: <FormattedMessage id="language.english" />
    }
  ]

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        background: theme.palette.gradient.primary,
        height: '68px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Box
        component="img"
        sx={{ height: '60%', marginLeft: '15px' }}
        alt="Moovy logo"
        src={Logo}
      />
      <FormControl variant="standard" sx={{ marginRight: '15px' }}>
        <Select
          aria-label="Kieli"
          IconComponent={() => <ExpandMoreIcon sx={{ color: 'white' }} />}
          disableUnderline
          labelId="select-language"
          id="kiosk-app-bar-select-lang"
          value={language}
          onChange={handleChange}
          sx={{ color: 'white' }}
        >
          {languageOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default KioskAppBar
